import React from 'react';
import RouterHealthBadge from './RouterHealthBadge';

const RouterListPanel = ({ routers, selectedRouterId, onSelect, isLoading }) => (
  <div className="rounded-xl border border-slate-800 bg-slate-900/70 p-3">
    <h2 className="mb-2 text-sm font-semibold uppercase tracking-[0.12em] text-cyan-200">Daftar Router</h2>
    <div className="max-h-[72vh] space-y-2 overflow-y-auto pr-1">
      {isLoading ? <p className="text-sm text-slate-400">Memuat router...</p> : null}
      {!isLoading && routers.length === 0 ? <p className="text-sm text-slate-500">Tidak ada data router</p> : null}
      {routers.map((router) => {
        const routerId = String(router.routerId || router.router_id || router.id || '');
        const selected = String(selectedRouterId) === routerId;
        return (
          <button
            type="button"
            key={routerId}
            onClick={() => onSelect(routerId)}
            className={`w-full rounded-lg border p-2 text-left transition ${
              selected ? 'border-cyan-400/60 bg-cyan-500/10' : 'border-slate-700 bg-slate-950/60 hover:border-slate-500'
            }`}
          >
            <div className="flex items-center justify-between gap-2">
              <p className="truncate text-sm font-semibold text-slate-100">{router.name || routerId}</p>
              <div className="flex items-center gap-1">
                <RouterHealthBadge isOnline={Boolean(router.isOnline ?? router.is_online)} />
                {router.hasMismatch ? (
                  <span className="inline-flex items-center rounded border border-amber-400/50 bg-amber-500/10 px-1.5 py-0.5 text-[10px] font-semibold text-amber-200">
                    !
                  </span>
                ) : null}
              </div>
            </div>
            <p className="mt-1 truncate text-xs text-slate-400">{router.vendor || '-'} | {router.mgmtIp || router.mgmt_ip || '-'}</p>
            <p className="mt-1 truncate text-xs text-cyan-300">Uplink: {router.primaryUplinkInterface || router.primary_uplink_interface || '-'}</p>
            <p className="mt-1 truncate text-[11px] text-slate-400">Source: {router.sourceAuthority || 'UNKNOWN'}</p>
          </button>
        );
      })}
    </div>
  </div>
);

export default RouterListPanel;
